<div class="container">
  <div class="container-card">
    <mat-card appearance="outlined" class="mat-component-background mat-elevation-z2">
      <mat-card-content>
        <p><strong>This page is the updated User Terms and Conditions; for the version effective until August 4th, 2025, click <a
            href="/user-terms-31-july-2024">here</a>.</strong></p>
      </mat-card-content>
    </mat-card>
  </div>

  <h1>User Terms</h1>

  <div class="container-last-updated">
    <em>Effective Date: August 4th, 2025 Last updated: July 1st, 2025</em>
  </div>

  <h2>We are so happy to have you join Planet VG!</h2>
  <p>
    Planet VG is the eco- and animal-friendliest way to claim vouchers, collect stamps and be rewarded for your
    loyalty.
    Before you dive in, take a moment to check out our Terms—they’re the basics to keep everything running smoothly.
    Should you, after reading them, have any questions or comments, you can always contact us. We’re more than happy to
    help.
  </p>
  <p>
    <em>
      By using our website(s) or consumer app (together called our <strong>“Services”</strong>), you agree that you’ve
      read, understood, and accepted
      our Terms. Using our Services for the first time means you accept these Terms. If you don’t agree, please don’t
      use them.
    </em>
  </p>

  <h2>1. Who are we?</h2>
  <p>
    <strong>1.</strong> Planet VG (<strong>“we”, “our”</strong>) is a trade name owned by Almost Level 5 B.V., a company
    with private limited liability
    under Dutch law, having its registered office at Oder 20 Unit E2574, 2491DC, The Hague (the Netherlands).
  </p>
  <p>
    <strong>2.</strong> If you have any questions, remarks or just want to share something, you can contact us in the
    following ways:
    <br />
    <br />
    By email: support&#64;planet.vg
    <br />
    By post: Almost Level 5 B.V., Oder 20 Unit E2574, 2491DC, The Hague (the Netherlands)
    <br />
    <br />
    And some important numbers:<br />
    Chamber of Commerce: 93949138<br />
    Dutch VAT-number: NL866583920B01
  </p>

  <h2>2. What do we offer and what is our mission?</h2>
  <p>
    <strong>1.</strong> Planet VG is a platform that connects climate-conscious and vegan individuals with businesses
    (our
    <strong>“Partners”</strong>)
    striving to make the world a better place. Through our Services, users can discover vouchers, collect loyalty
    stamps, and earn
    rewards for supporting local, eco-friendly, and vegan businesses. Our mission is to bring these communities closer
    together and
    promote sustainable choices.
  </p>
  <p>
    <strong>2.</strong> By signing up or using the Services, you can earn points or stamps through promotional
    activities and redeem them
    for gifts chosen
    by our Partners. You’ll also gain access to promotional and marketing content shared by our Partners.
  </p>
  <p>
    <strong>3.</strong> You understand that Planet VG is not an intermediary, agent, or mediator. We simply provide our
    Services to help
    users and Partners
    connect with each other. We do not control or oversee the goods, services, rewards, gifts or offers provided by
    Partners, nor do we guarantee
    their quality, availability, or suitability. Any transactions, agreements, or interactions you have with a Partner
    are strictly between you
    and that Partner. Planet VG is not a party to these agreements and is not responsible for any disputes, issues, or
    problems that may arise.
  </p>
  <p>
    <strong>4.</strong> We are also not responsible for verifying or ensuring the accuracy, and completeness of any
    content provided by
    Partners. Partners operate
    independently and are not our employees, agents, or representatives. Whatever they do, say, or promise, is totally
    on them.
  </p>

  <h2>3. Who can use our Services?</h2>
  <p>
    <strong>1.</strong> We welcome all animal lovers, sustainability enthusiasts, and anyone passionate about creating a
    kinder world to
    use our Services, as long
    as you agree to follow these Terms. By accessing or using our Services, you confirm that you accept these Terms and
    will comply with them.
  </p>
  <p>
    <strong>2.</strong> To access and use our Services, you must meet the following conditions:
  </p>
  <ul>
    <li>You must be at least 16 years old.</li>
    <li>You agree to use the Services solely for your own personal purposes.</li>
    <li>You agree to use the Services in a manner consistent with our core values of compassion, sustainability, and
      respect for all living beings.</li>
  </ul>

  <h2>4. Do you need an account?</h2>
  <p>
    <strong>1.</strong> Yes, to use our Services, you’ll need to create an account. This means you’ll provide accurate
    and up-to-date
    information,
    choose a secure username and password, and agree to the following:
  </p>
  <ul>
    <li>You may only have one active account at a time. If we discover that you have multiple accounts, we may close
      some or all of them.</li>
    <li>Your username must not violate anyone else’s rights, such as by impersonating another person or using a name you
      are not entitled to.</li>
    <li>Your account is personal and cannot be transferred to anyone else without our prior written consent.</li>
  </ul>

  <p>
    <strong>2.</strong> Remember, you are solely responsible for all activity that takes place under your account. We
    also reserve the
    right to refuse any registration
    request at our discretion, without providing a reason.
  </p>

  <p>
    <strong>3.</strong> If you suspect any unauthorized access, security breach, or potential compromise of your login
    information, you
    must contact us immediately at support&#64;planet.vg.
  </p>

  <h2>5. Are there restrictions on how you can use the Services?</h2>
  <p>
    <strong>1.</strong> Yes, we expect you to behave respectfully. Planet VG is built on kindness. To keep Planet VG a
    fair and secure
    platform, here’s a list of activities that are prohibited:
  </p>
  <ul>
    <li>Don’t post spam, junk mail, or any unsolicited content.</li>
    <li>Don’t share anything that infringes on intellectual property, privacy, or legal rights.</li>
    <li>Don’t share unlawful, (animal) abusive, discriminatory, or harmful content.</li>
    <li>Don’t spread false, misleading, or inaccurate information.</li>
    <li>Don’t hack, reverse-engineer, or access our systems without permission.</li>
    <li>Don’t stalk, harass, or violate someone’s privacy or rights.</li>
    <li>Don’t harm, overload, or disrupt the platform.</li>
    <li>Don’t use Planet VG to attract users or businesses to competing services.</li>
    <li>Don’t exceed reward limits set by Partners.</li>
    <li>Don’t copy or store large chunks of content from Planet VG.</li>
  </ul>
  <p>
    <strong>2.</strong> When sharing feedback with our Partners, keep it real, honest, and on point. If your feedback
    gets flagged as
    fake
    or inaccurate three times (or more), we might deactivate your account, and yep, your rewards could be gone too.
  </p>
  <p>
    <strong>3.</strong> Any rewards you obtain through our Services cannot be combined with other rewards. They also
    cannot be redeemed
    or exchanged for cash.
  </p>
  <p>
    <strong>4.</strong> Rewards you earn through our Services come with a validity period. If you don’t use or claim
    them within that
    time, they’ll expire.
    Additionally, each reward can only be claimed and redeemed once by you.
  </p>

  <h2>6. Is Planet VG free to use?</h2>
  <p>
    <strong>1.</strong> For now, we provide our Services to you for free (yay!). However, we may decide to start
    charging fees for access
    to the Services or
    specific functionalities at any time. We also reserve the right to modify or discontinue certain free Services as
    needed.
  </p>
  <p>
    <strong>2.</strong> If we introduce fees in the future, users with valid accounts will be notified in advance. You
    can then decide
    whether to keep or
    delete your account. If you choose to continue using our Services after fees are introduced, you will be responsible
    for all associated
    charges.
  </p>

  <h2>7. Will these Terms ever change?</h2>
  <p>
    <strong>1.</strong> We’re always evolving and improving our Services, so our Terms may change as we update and
    enhance what we
    offer. While we can change
    these Terms at any time, we’ll make sure you’re aware by posting a notice on our site or reaching out in another
    way, with the exception
    of changes that are in your favor or not considered substantial (‘minor changes’).
  </p>
  <p>
    <strong>2.</strong> If you don’t agree with the updated Terms, you’re free to decline them—but that means you won’t
    be able to use
    our Services anymore.
    By continuing to use the Services after the changes go into effect, you’re confirming your acceptance of the new
    Terms.
  </p>

  <h2>8. What does it mean that we provide the Services to you “as is” and “as available”?</h2>
  <p>
    <strong>1.</strong> At Planet VG, we want to be clear about how we offer our Services. We provide them "as is" and
    "as available,"
    which means that while we work hard to provide you with a great experience, we can't guarantee that everything will
    always run perfectly. This means, for example, that:
  </p>
  <ul>
    <li>Sometimes, our Services might not be available due to maintenance, updates, or other reasons. We aren’t liable
      for any issues caused by the Services being unavailable.</li>
    <li>We can't promise that you'll always have uninterrupted or problem-free access to the Services, including your
      account.</li>
    <li>While we aim to keep everything safe, we can't guarantee that the Services are free from viruses or other
      harmful software.</li>
    <li>We can (temporarily) stop access to our Services or change/remove features at any time without letting you know
      first. If this happens, we won’t owe you any compensation. Also, any rewards you’ve collected might no longer be
      valid.</li>
    <li>We are not responsible for ensuring that our Partners fulfill their promises, including providing rewards.</li>
  </ul>

  <h2>9. What’s next for Planet VG?</h2>
  <p>
    <strong>1.</strong> Planet VG is always evolving to be better. This means we can tweak, update, or change the
    Services
    anytime—whether that’s adding cool new features, removing outdated ones, or even pausing parts of the Services
    temporarily or permanently.
  </p>
  <p>
    <strong>2.</strong> We love hearing your ideas, but the final call is up to us.
  </p>

  <h2>10. What license do you get from us?</h2>
  <p>
    <strong>1.</strong> Everything you see on Planet VG - like text, graphics, logos, images, and software - belongs to
    us or our
    licensors (including Partners).
    That includes updates, upgrades, and all future versions.
  </p>
  <p>
    <strong>2.</strong> You get a limited, non-exclusive, non-transferable license to use Planet VG for personal,
    non-commercial fun, as
    long as you stick to the rules. If your account is terminated, this license ends immediately.
  </p>
  <p>
    <strong>3.</strong> We hold full ownership of everything on Planet VG, including rights we haven’t explicitly shared
    with you in
    these Terms.
  </p>

  <h2>11. What if you want to stop using the Services?</h2>
  <p>
    <strong>1.</strong> You can stop using the Services at any time by deleting your account, as long as you are no
    longer linked to a
    Planet VG Partner account. If you are linked to a Partner account, you must terminate that account first.
  </p>
  <p>
    <strong>2.</strong> If you break the rules, we might need to pause or close your account. Don’t worry—we’ll always
    try to be fair and
    make the best call based on the situation.
  </p>
  <p>
    <strong>.</strong> Deleting or terminating your account can lead to losing any content or benefits tied to it, like
    rewards. Please
    consider this carefully before deciding to delete your account!
  </p>

  <h2>12. What about third-party links and content?</h2>
  <p>
    <strong>1.</strong> We may include links to third-party websites for your convenience. These websites are not under
    our control. We
    are not responsible for the content, actions, or practices of these third-party websites. If you choose to access
    them, you do so at your own risk.
  </p>
  <p>
    <strong>2.</strong> Our Services may also include access to third-party content, such as content from our Partners.
    Since we cannot
    review all content shared through our Services, we are not responsible for its accuracy, quality, or impact. This
    means you might come across content that is inaccurate, poor in quality, or even offensive. We cannot and will not
    be held liable for
    any loss or damage caused by such content.
  </p>

  <h2>13. What if you have a complaint?</h2>
  <p>
    <strong>1.</strong> Got a complaint about how Planet VG works? Reach out to us at support&#64;planet.vg. If your
    complaint is about a
    Partner (like issues with rewards), you’ll need to contact them directly. Since the agreement is between you and the
    Partner, we can’t step in on those. For complaints we can handle, we’ll do our best to get back to you within 5
    days.
  </p>

  <h2>14. Is Planet VG liable if something goes wrong?</h2>
  <p>
    We strive to offer reliable, high-quality Services, but occasionally, things might not go as expected. Here’s what
    you should know about our liability:
  </p>
  <p>
    <strong>1.</strong> To the fullest extent permitted by applicable law, we are not responsible for:
  </p>
  <p>
    (i) Any direct, indirect, incidental, punitive, or consequential damages, including but not limited to loss of data,
    or other non-direct losses.
  </p>
  <p>
    (ii) Any issues arising from third-party content.
  </p>
  <p>
    (iii) Any actions, omissions, or obligations of our Partners, including the quality, accuracy, availability, or
    legality of their products, services, or rewards.
  </p>
  <p>
    <strong>2.</strong> We only take responsibility for damages caused by our intent or gross negligence, as required by
    applicable law.
  </p>
  <p>
    <strong>3.</strong> Some jurisdictions don’t allow exclusions or limitations of certain damages, so parts of this
    clause may not
    apply to you.
  </p>

  <h2>15. What laws apply and where can disputes be resolved?</h2>
  <p>
    <strong>1.</strong> We’re all about keeping things friendly, but if we can’t work something out together (and
    mandatory law doesn’t
    say otherwise), any disputes about Planet VG will go to the qualified Dutch court in our district. Let’s hope it
    never comes to that.
  </p>
  <p>
    <strong>2.</strong> Everything about your use of Planet VG, these Terms, and any agreements based on them is
    governed by Dutch law.
    Don’t worry, your rights under mandatory consumer laws stay fully protected.
  </p>

  <h2>16. What else do I need to know?</h2>
  <p>
    <strong>1.</strong> If you misuse Planet VG, break the rules, or infringe on someone else’s rights, you agree to
    cover any claims,
    losses, or costs we face because of it.
  </p>
  <p>
    <strong>2.</strong> If part of these Terms turns out to be invalid or unenforceable, the rest still stands strong.
    We’ll replace any
    invalid bits with something that works and keeps the same vibe.
  </p>
  <p>
    <strong>3.</strong> We can transfer our rights and responsibilities under this agreement to a third party.
  </p>
</div>